"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calcBoilGravity = exports.calcFinalGravity = exports.calcOriginalGravity = exports.calcTotalGravityPoints = void 0;
const utils_1 = require("./utils");
const units_1 = require("./units");
// Sugar provides 46 gravity points per pound, per gallon (PPPG).
// 1 pound = 16 oz (weight/mass)
// 1 gallon = 128 fl oz
// yield and efficiency should be parsed from recipe as percent values
// The maximum potential is approximately 1.046 which would be a pound of pure sugar in a gallon of water.
const yieldToPotential = (fermentableYield) => ({
    value: (fermentableYield.value * 0.01 * 46) / 1000 + 1,
    unit: 'sg',
});
const calcFermentableEfficiency = (type, equipmentEfficiency, sugarEfficiency = 1) => type === 'extract' || type === 'sugar' || type === 'dry extract'
    ? sugarEfficiency
    : equipmentEfficiency;
const calcFermentablePotential = (fermentableYield) => {
    if (fermentableYield.potential != null) {
        return fermentableYield.potential;
    }
    if (fermentableYield.fine_grind != null) {
        return yieldToPotential(fermentableYield.fine_grind);
    }
    if (fermentableYield.coarse_grind != null) {
        return yieldToPotential(fermentableYield.coarse_grind);
    }
    return { value: 0, unit: 'sg' };
};
const calcFermentableGravityPoints = (fermentable, brewhouseEfficiency = { value: 100, unit: '%' }, attenuation = { value: 0, unit: '%' }) => {
    const amountValue = units_1.convertMeasurableValue(fermentable.amount, 'lb');
    const potentialValue = units_1.convertMeasurableValue(calcFermentablePotential(fermentable.yield), 'sg');
    const efficiencyValue = (1 - attenuation.value / 100) *
        calcFermentableEfficiency(fermentable.type, brewhouseEfficiency.value / 100);
    return (potentialValue - 1) * amountValue * efficiencyValue;
};
const calcTotalGravityPoints = (fermentables, efficiency, attenuation) => utils_1.sum(fermentables.map((fermentable) => calcFermentableGravityPoints(fermentable, efficiency.brewhouse, attenuation)));
exports.calcTotalGravityPoints = calcTotalGravityPoints;
const calcGravity = (batchSize, gravityPoints) => {
    return 1.0 + gravityPoints / units_1.convertMeasurableValue(batchSize, 'gal');
};
const boilGravity = (batchSizeInGallons, boilSizeInGallons, ogInSG) => 1 + ((ogInSG - 1) * batchSizeInGallons) / boilSizeInGallons;
const calcOriginalGravity = (batchSize, fermentables, efficiency) => {
    const ogValue = calcGravity(batchSize, exports.calcTotalGravityPoints(fermentables, efficiency));
    return {
        unit: 'sg',
        value: ogValue,
    };
};
exports.calcOriginalGravity = calcOriginalGravity;
const calcFinalGravity = (batchSize, fermentables, efficiency, cultures) => {
    const fgValue = calcGravity(batchSize, exports.calcTotalGravityPoints(fermentables, efficiency, cultures[0].attenuation));
    return {
        unit: 'sg',
        value: fgValue,
    };
};
exports.calcFinalGravity = calcFinalGravity;
const calcBoilGravity = (batchSize, boilSize, OG) => {
    return {
        unit: 'sg',
        value: boilGravity(units_1.convertMeasurableValue(batchSize, 'gal'), units_1.convertMeasurableValue(boilSize, 'gal'), units_1.convertMeasurableValue(OG, 'sg')),
    };
};
exports.calcBoilGravity = calcBoilGravity;
//# sourceMappingURL=gravity.js.map